import AuditPersonDetails from '@components/AuditPersonDetailsComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import PageWithoutTitle from '@components/PageWithoutTitle';
import UserRadioSelect from '@components/userRadioSelectComponent';
import NotificationComponent from '@helpers/_showNotifications';
import { AuditPersonType } from '@interfaces/audit-person-type';
import { IAudited } from '@interfaces/ehss/Audited';
import { IAuditor } from '@interfaces/ehss/Auditor';
import { IUser as UserInterface } from '@interfaces/IUser';
import AppContext from '@services/Context';
import AuditedService from '@services/ehss/Audited';
import AuditorService from '@services/ehss/Auditor';
import ConfigService from '@services/global/Config';
import styled from '@src/styled-components';
import { Button, Modal, Row } from 'antd';
import React, { Component } from 'react';

import I18n from '../i18n';


interface IAuditorDetailsPropType {
  history: {
    replace: Function
  };
  match: any;
}

interface IAuditorDetailsStateType {
  auditedsByAuditor: number;
  auditedsData: IAudited[];
  auditedsGoal: number;
  auditsGoal: number;
  curOffset?: string;
  curUsersOffset?: string,
  fields: any;
  filteredTableData: IAuditor[];
  haveUserSelected: boolean;
  historyData: any;
  iconLoading?: boolean;
  isLoading: boolean;
  loadingMoreAuditors: boolean;
  loadingMoreUsers: boolean;
  loadingUsersBySearch: boolean;
  noUserFound: boolean;
  personData?: IAuditor;
  savingAuditor: boolean;
  searchAuditor: string;
  searchUser: string;
  serverResponse: any;
  showFormModal: boolean;
  tableData: IAuditor[];
  totalShowData?: number;
  usersData: any[];
  userSelectedItem: string;
  usersAmount: number;

  currentProcessId: string;
  currentAuditName: string;
  currentAuditGoals?: any;
  currentAuditedsMinByAuditor?: any;
  currentAuditedsMaxByAuditor?: any;
  auditGoal: any;
};

const tableColumns = [
  {
    title: 'table.users.audited',
    dataIndex: 'name',
    key: 'name',
    width: '20%',
  },
  {
    title: 'table.auditors.registration',
    dataIndex: 'username',
    key: 'username',
    width: '20%',
  },
  {
    title: 'table.auditors.audistMonth',
    dataIndex: 'audits',
    key: 'audits',
    width: '20%',
  },
  {
    title: 'table.actions',
    dataIndex: 'action',
    key: 'action',
    width: '20%',
  }];


export default class AuditorDetails extends Component<IAuditorDetailsPropType, IAuditorDetailsStateType> {

  private idUnit: any = undefined;
  private _auditorService: AuditorService;
  private _auditedService: AuditedService;
  private _configService: ConfigService;

  private _idPerson = this.props.match.params.id;

  private auditorDetailsRef: any;

  constructor(props: any) {
    super(props);

    this._auditorService = new AuditorService();
    this._auditedService = new AuditedService();
    this._configService = new ConfigService();

    this.auditorDetailsRef = React.createRef();

    this.state = {
      isLoading: true,
      showFormModal: false,
      iconLoading: false,
      personData: undefined,
      tableData: [],
      usersData: [],
      auditedsData: [],
      totalShowData: 5,
      filteredTableData: [],
      curOffset: undefined,
      curUsersOffset: undefined,
      userSelectedItem: '',
      haveUserSelected: false,
      loadingUsersBySearch: false,
      loadingMoreUsers: false,
      loadingMoreAuditors: false,
      savingAuditor: false,
      auditsGoal: 0,
      auditedsGoal: 0,
      auditedsByAuditor: 0,
      searchUser: '',
      searchAuditor: '',
      serverResponse: undefined,
      noUserFound: false,
      fields: undefined,
      historyData: undefined,
      usersAmount: 0,
      currentProcessId: '',
      currentAuditName: '',
      auditGoal: 0
    }
  }

  setUnit(unitId: string) {
    this.idUnit = unitId;
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.getConfig();
  }

  toggleAuditedSelectModal = () => {
    if (!this.state.showFormModal)
      this.getUsers(true, '');
    this.setState({
      usersData: [],
      userSelectedItem: '',
      haveUserSelected: false,
      searchUser: '',
      showFormModal: !this.state.showFormModal,
      serverResponse: undefined,
      loadingUsersBySearch: true,
      noUserFound: false,
    });
  };

  auditChanged = (auditId: string) => {
    this.setState({ currentProcessId: auditId });
  }

  auditChangedName = async (auditName: string) => {
    this.setState({ currentAuditName: auditName });
  }
  auditGoals = async (auditGoals: string) => {
    this.setState({ currentAuditGoals: auditGoals });
  }
  setAuditedMinByAuditor = async (value: string) => {
    this.setState({ currentAuditedsMinByAuditor: value });
  }
  setAuditedMaxByAuditor = async (value: string) => {
    this.setState({ currentAuditedsMaxByAuditor: value });
  }


  getConfig = async () => {
    const responseGlobal = await this._configService.getGLOBAL(['userFields']);

    if (responseGlobal != undefined) {
      this.setState({
        fields: responseGlobal,
      });
    }
    this.getAuditorInfo();
  }

  getAuditorInfo = async () => {
    const response = await this._auditorService.getById(this._idPerson);
    try {
      if (response.auditor != undefined) {
        this.setState({
          isLoading: false,
          personData: response,
        });

      }
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
      this.setState({
        savingAuditor: false,
        isLoading: false,
      });
    }
  }

  handleUsersSearch = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;

    await this.setState({
      loadingUsersBySearch: true,
      searchUser: SearchValue,
    })
    try {
      this.getUsers(true, SearchValue);
    }
    catch (err) {
      console.log(err)
    }
  };

  handleUserSearchChange = (e: any) => {
    this.setState({
      searchUser: e.target.value,
    })
  }

  loadMoreUsers = () => {
    this.setState({ loadingMoreUsers: true, });
    this.getUsers(false, this.state.searchUser);
  }

  getUsers = async (reset: boolean, user?: string) => {
    if (reset) {
      this.setState({
        curUsersOffset: undefined
      });
    }
    try {
      if (user != undefined) {
        const data = await this._auditedService.paging({
          unit: this.idUnit,
          to: undefined,
          from: undefined,
          search: user,
          disabled: false,
          limit: 6,
          process: this.state.currentProcessId,
          offset: this.state.curUsersOffset,
          hasNoAuditor: true
        });
        let nextUsersData: any[] = [];

        if (!reset) {
          nextUsersData = this.state.usersData || [];
        }

        nextUsersData = nextUsersData.concat(data.items);

        nextUsersData.forEach((item: any, i: number) => {
          let goalExecuted = item.audited.goals.find((e: any) => e.process === this.state.currentProcessId)
          nextUsersData[i].auditedGoal =
            <div>
              {`${goalExecuted == undefined ? 0 : goalExecuted.auditExecuted} ${I18n.l('common.processes')} ${I18n.l('common.of')} ${this.state.currentAuditGoals}`}
            </div>

        })

        this.setState({
          usersData: nextUsersData,
          curUsersOffset: data.offset,
          noUserFound: nextUsersData.length == 0,
          loadingMoreUsers: false,
          usersAmount: data.count,
          loadingUsersBySearch: false,
        });
      }
      else {
        this.setState({
          usersData: [],
          curUsersOffset: undefined,
          loadingMoreUsers: false,
          loadingUsersBySearch: false,
          noUserFound: false,
        });
      }
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
    }
  }

  unlinkAudited = async (audited: string) => {
    const processId: string = this.state.currentProcessId;
    try {
      await this._auditorService.auditedRemove(this._idPerson, audited, processId);

      this.auditorDetailsRef.current.auditedRemoved(processId, audited);
      const { auditedsData } = this.state;
      const nextAuditedsData = auditedsData.filter((item: IAudited) => item.id !== audited);

      this.setState({
        isLoading: false,
        auditedsData: nextAuditedsData,
      });

      // this.getAuditeds();

    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.unlink"), e);
      console.error(e);
    }
  };

  onSubmitAuditedSelected = async () => {
    this.setState({ savingAuditor: true });
    const { userSelectedItem } = this.state;
    const processID: string = this.state.currentProcessId;
    try {
      const user = this.state.usersData.filter((i: UserInterface) => i.id === userSelectedItem)[0];
      const response = await this._auditorService.auditedAdd(this._idPerson, user.id, processID);
      // this.getAuditeds();
      this.auditorDetailsRef.current.auditedAdded(processID, response);
      this.setState({
        showFormModal: false,
        savingAuditor: false,
      });
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.auditedLinkedSuccess"));
    }
    catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.select"), error);
      this.setState({
        showFormModal: false,
        savingAuditor: false,
      });
    }
  };

  onRadioItemSelectionChange = async (userId: string) => {
    this.setState({
      haveUserSelected: !!userId,
      userSelectedItem: userId,
    });
  }

  searchChange = async (event: any) => {
    event.preventDefault();
    this.setState({
      searchAuditor: event.target.value
    })
  };

  getPersonDataLength(personData: any){
    if(personData && personData.auditor && personData.auditor.processes){
      return personData.auditor.processes.length 
    }
    return 0
  }
  render() {
    const {
      isLoading,
      showFormModal,
      personData,
      tableData,
      usersData,
      haveUserSelected,
      loadingMoreUsers,
      savingAuditor,
      loadingUsersBySearch,
      userSelectedItem,
      searchUser,
      auditsGoal,
      noUserFound,
      fields,
    } = this.state;
    const processesLength = this.getPersonDataLength(personData)
    if (!!isLoading) {
      return (
        <span>{I18n.l('common.loadingTable')}</span>
      );
    }

    return (
      <PageWithoutTitle>
        <AppContext.Consumer>
          {({ activeUnitId }) => (
            this.setUnit(activeUnitId),
            <Wrapper>
              {personData != undefined && (
                <AuditPersonDetails
                  personData={personData}
                  tableData={tableData}
                  auditPersonType={AuditPersonType.AUDITOR}
                  audits={processesLength}
                  onUnlink={this.unlinkAudited}
                  auditsGoal={auditsGoal}
                  auditedsGoal={this.state.currentAuditGoals}
                  fields={fields}
                  auditChanged={this.auditChanged}
                  auditChangedName={this.auditChangedName}
                  auditGoals={this.auditGoals}
                  tableColumns={tableColumns}
                  auditedsMinByAuditor={this.state.currentAuditedsMinByAuditor}
                  auditedsMaxByAuditor={this.state.currentAuditedsMaxByAuditor}
                  toggleUserFormModal={this.toggleAuditedSelectModal}
                  actionUnlinkTest={I18n.l('common.unlink') + " " + I18n.l('labels.audited').toLowerCase()}
                  unlinkModalTitle={I18n.l('common.unlink') + " " + I18n.l('labels.audited').toLowerCase()}
                  ref={this.auditorDetailsRef}
                  auditor={true}
                />
              )}

              {/* CHOOSE USER AS AUDITOR MODAL */}
              {showFormModal && (
                <LargeModal>
                  <Modal visible={showFormModal} width='60%' wrapClassName={"large-modal"} footer={false} closable={false} >
                    <p style={{ fontWeight: 'bold', color: 'black' }} >{this.state.currentAuditName}</p>
                    <ModalTitle>{I18n.l('form.titles.auditedLinkSelectForm')}</ModalTitle>
                    <ModalContent>
                      <SearchAudited>
                        <SearchComponent
                          onSubmit={this.handleUsersSearch}
                          placeholder='form.placeholders.alertsSearch'
                          buttonText='form.buttons.search'
                        />
                      </SearchAudited>
                      {usersData && usersData.length > 0 && (
                        <UserRadioSelect
                          data={usersData}
                          itemSelectionChanged={(userId: string) => this.onRadioItemSelectionChange(userId)}
                          loadingMoreData={loadingMoreUsers}
                          hasMoreData={this.state.curUsersOffset !== undefined && this.state.curUsersOffset !== null ? true : false}
                          onShowMore={this.loadMoreUsers}
                          valueSelected={userSelectedItem}
                        >
                        </UserRadioSelect>
                      )}
                      {usersData.length == 0 && loadingUsersBySearch === false && noUserFound == true && searchUser.length == 0 && (
                        <p className="goepik-component-padding">{I18n.l('titles.noAuditorRegistered')}</p>
                      )}
                      {loadingUsersBySearch === true && (
                        <p className="goepik-component-padding">{I18n.l('common.loadingTable')}</p>
                      )}
                      {(usersData && !!noUserFound && usersData.length === 0 && searchUser && searchUser.length > 0 && loadingUsersBySearch == false) && (
                        <p className="goepik-component-padding">{I18n.l('common.noResultAudited')}</p>
                      )}

                      <p className="goepik-component-padding"></p>
                      <Row type="flex" justify="end">
                        <Button className="main-button" type="primary" ghost size="large" onClick={this.toggleAuditedSelectModal}>
                          {I18n.l('common.cancel')}
                        </Button>
                        <Button className="main-button" type="primary" size="large" loading={savingAuditor} onClick={() => this.onSubmitAuditedSelected()} disabled={!haveUserSelected}>
                          {I18n.l('common.select')}
                        </Button>
                      </Row>

                    </ModalContent>
                  </Modal>
                </LargeModal>
              )}
            </Wrapper>
          )}
        </AppContext.Consumer>
      </PageWithoutTitle>
    );
  }
}



const LargeModal = styled.div`
    .large-modal{
        width: 45%;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .emptyRowData{
        font-weight:bold;
        color:#B5B5B5;
    }

    .loading-more {
        margin: 15px 0;
        padding: 0;
        border: 0;
        text-align: left
    }

    

    .filter-group {
        margin-bottom: 50px;
    }
    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }

    hr{
        opacity: .6;
    }

`;


const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
`;
const SearchAudited = styled.div`
    .search-component {
        max-width: 100% !important
    }
`;
const ModalContent = styled.div`
  width: 100%;
    .goepik-component-padding{
        color:#a3a3a3;
        font-weight:bold;
        font-size:14px;
    }
    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    .searchBtn{
        border-color: #1890ff;
        color: #1890ff;
    }
    .margied-elements{
        margin-left:10px;
    }
`;